module.exports = __webpack_public_path__ + "static/cs-wordmark-white-755f9fda4b1f0d7c2f1fe64465da474e.png";